// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__H7e0a","social-links":"Footer_social-links__d+TmA","social-link":"Footer_social-link__MsZar"};